import React from 'react';

export interface WindowContextValue {
  open: (url: string, name: string, specs: string) => Window | null;
  locationAssign: (url: string) => void;
}

export default React.createContext<WindowContextValue>({
  open: (url: string, name: string, specs: string) =>
    window.open(url, name, specs),
  locationAssign: (url: string) => {
    window.location.href = url;
  },
});
